exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lmig-A11yOnly{border:0;clip:rect(0 0 0 0);height:1px;width:1px;overflow:hidden;padding:0;position:absolute}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"includePaths":["./node_modules"]}!./node_modules/@lmig/lmds-react-a11y/dist/_esm/a11yOnly.css
// module id = 1549
// module chunks = 0